module.exports = __webpack_public_path__ + "static/media/community.153c64b2.jpg";